import { compose } from 'recompose';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectors as settingsSelectors } from 'state/settings';

import HelpContact from 'components/ModalFaqs/Sections/FaqsWithMarkup/HelpContact/component';

const enhance = compose(
  withTranslation('Faqs'),
  connect(
    (state) => ({
      contactPhone: settingsSelectors.getContactPhoneWithAreaCode(state),
      contactMail: settingsSelectors.getOpsMail(state),
    }),
    {}
  )
);

export default enhance(HelpContact);
